import './index.less';

//checkApp 为全局的 app 对象，checkApp.core 包括了核心 api 
const { Feature, meta, hook } = checkApp.core;//eslint-disable-line
const { Button } = checkApp.components;//eslint-disable-line

const priceUrl = '//wanwang.aliyun.com/help/price.html';

//通过继承 Featrue 实现一个扩展
//meta 用于描述插件的名称、依赖及权重
@meta('price-list', [], 99999)
export default class PriceListFeature extends Feature {

  @hook('menu.content')
  createButton() {
    return <a className='pull-right price-list item'
      target="_blank" href={priceUrl}>价格总览></a>;
  }

}


// WEBPACK FOOTER //
// ./src/menu/index.js